export default __webpack_public_path__ + "static/media/admin_icon.6ce1d3e0.png";